import { render, staticRenderFns } from "./cataloguePavilion.vue?vue&type=template&id=878aed78&scoped=true&"
import script from "./cataloguePavilion.vue?vue&type=script&lang=js&"
export * from "./cataloguePavilion.vue?vue&type=script&lang=js&"
import style0 from "./cataloguePavilion.vue?vue&type=style&index=0&id=878aed78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878aed78",
  null
  
)

export default component.exports